export default "__VITE_ASSET__61a6a155__"